import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useState, useRef, useCallback } from 'react';
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { ResizeDetector } from '@/components/functional/Resize/ResizeDetector';
import { Text } from '@/components/ui/Typography/Body/Text';
import { WithUnitText } from '@/components/ui/Typography/Body/WithUnitText';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
const withUnitTextClassName = {
    wrap: clsx('flex shrink-0 items-baseline', 'max-w-[42px]'),
};
/**
 * 記事一覧ページの上部に表示するリンク用のListItem
 *
 * @param props
 * @constructor
 */
export const ArticleLinkListItem = (props) => {
    const { className = '', count: propCount, icon: Icon, isActive, onClick, text, to, } = props;
    const textRef = useRef(null);
    const [isEllipsis, changeIsEllipsis] = useState(false);
    // アイコンとテキストの色
    const color = isActive ? 'white' : 'primary';
    // リサイズ時の要素幅に応じて、折り返し表示を制御する（文字のはみ出しを防止）
    const onResize = useCallback((width) => {
        // refが存在しない場合は何もしない
        if (!textRef.current || width === undefined) {
            return;
        }
        const { offsetWidth, scrollWidth } = textRef.current;
        // ellipsisによる省略が発生しているか
        changeIsEllipsis(offsetWidth < scrollWidth);
    }, [textRef, changeIsEllipsis]);
    // 件数表示
    const count = (() => {
        if (propCount === undefined) {
            // 値が存在しない場合
            return '-';
        }
        return isEllipsis && propCount >= 100 ? '99+' : propCount;
    })();
    return (_jsx(ResizeDetector, Object.assign({ onResize: onResize, targetRef: textRef }, { children: _jsxs(DynamicLink, Object.assign({ className: clsx('flex items-center justify-between gap-x-4', 'w-full h-[40px]', 'px-8 lg:px-12', isActive
                ? 'bg-navy-100'
                : 'transition-[background] bg-white border-gray-300 hover:bg-gray-75 ', className), noLinkElement: isActive ? 'div' : undefined, onClick: onClick, to: to }, { children: [_jsxs(IconTextGroup, Object.assign({ className: clsx('overflow-hidden', 'w-full', 'lg:gap-8'), space: 'normal' }, { children: [_jsx(Icon, { color: color, size: 'md' }), _jsx(Text, Object.assign({ className: clsx('w-full', 'lg:text-text-sm', 'whitespace-nowrap', 'overflow-hidden text-ellipsis'), color: color, size: 'xs', tagRef: textRef }, { children: text }))] })), _jsx(WithUnitText, { classNames: withUnitTextClassName, mainColor: 'secondary', mainText: count, size: 'xxs', unitColor: color, unitText: '件' })] })) })));
};
